import { render } from "./MateriallDescription.vue?vue&type=template&id=75d522e2&ts=true"
import script from "./MateriallDescription.vue?vue&type=script&lang=ts"
export * from "./MateriallDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__